export const ProcessingStatuses = {
  PENDING: 'PENDING',
  ERROR: 'ERROR',
  COMPLETE: 'COMPLETE',
} as const;
